$xhr = "";
$xhrCount = '';
$ajax_call_stone_list_running = "No";
$stoneTotal = $pageCount = 0;
let isStoneSelected = false;
let ringSize = '';
const API_URL = "https://console-shopify.ringbuilder.io/frontend.php";

$(document).ready(async function () {
    const params = new URLSearchParams(window.location.search);
    isStoneSelected =
        (params.has('labgrown_stock_num') && params.get('labgrown_stock_num').trim() !== '') ||
        (params.has('natural_stock_num') && params.get('natural_stock_num').trim() !== '');

    ringSize = params.get('ring_size');

    const currentUrl = window.location.pathname;
    // Get product handle from URL
    const settingHandle = currentUrl.split('/products/')[1];

    let settingProductVariant = params.get("variant");

    try {
    if (isStoneSelected) {
        const stockNumParam = params.get('natural_stock_num') ? 'natural_stock_num' : 'labgrown_stock_num';
        const stockNum = params.get(stockNumParam);
        const diamond_type = stockNumParam == 'natural_stock_num' ? 'natural' : 'labgrown';

        let diamondPlpUrl = '/collections/diamonds?';
        diamondPlpUrl += `setting-handle=${encodeURIComponent(settingHandle)}`;
        diamondPlpUrl += `&variant=${encodeURIComponent(settingProductVariant)}`;
        diamondPlpUrl += `&origin=${encodeURIComponent(diamond_type)}`;
        diamondPlpUrl += `&stone_view=list_view`;

        $(".vdbrc_view_diamond").attr('href', diamondPlpUrl);

        if (stockNum && stockNum !== '') {
            const response = await get_stone_info(stockNum, stockNumParam);

            if (response && response.success === true && response.data) {
                const stone = response.data;

                const stock_num = stone["stock_num"];
                const stock_id = stone["id"];
                const vendor_id = formatValue(stone["vendor_id"]);
                const lab = formatValue(stone["lab"]);
                const shape = formatValue(stone["shape"]);
                const size = formatSize(stone["size"]);
                const clarity = formatValue(stone["clarity"]);
                const cut = formatValue(stone["cut"]);
                const image_url = formatValue(stone["image_url"]);
                const color = formatValue(stone["color"]);
                const polish = formatValue(stone["polish"]);
                const symmetry = formatValue(stone["symmetry"]);
                const depth_per = formatValue(stone["depth_percent"]);
                const table_per = formatValue(stone["table_percent"]);
                const video_url = formatValue(stone["video_url"]);
                const cert_url = formatValue(stone["cert_url"]);
                const video_type = formatValue(stone["video_type"]);
                const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
                const total_sales_price = stone["total_sales_price"];
                const long_title = formatValue(stone["long_title"]);
                const fluorescence = formatValue(stone["fluor_intensity"]);
                const culet = formatValue(stone["culet_condition"]);

                const measurements_arr = [
                    formatValue(stone["meas_length"], "0.00"),
                    formatValue(stone["meas_width"], "0.00"),
                    formatValue(stone["meas_depth"], "0.00"),
                ];

                const measurements = measurements_arr.every((element) => element === "0.00")
                    ? "-"
                    : measurements_arr.join(" x ");

                const price = handlePriceData(stone_currency_code, total_sales_price);
                const price_without_format = handlePriceData(stone_currency_code, total_sales_price, true);

                const originLabel = diamond_type === "natural" ? "Natural" : "Lab Grown";
                const originValue = diamond_type === "natural" ? "NATURAL" : "LAB GROWN";

                // const productTitle = diamond_type === "natural" ? "NATURAL DIAMOND" : "LAB GROWN DIAMOND";
                const certifiedTitle = diamond_type === "natural" ? "Natural Diamond" : "Lab Grown Diamond";

                const productTitle = [
                    size ? `${size} Carat` : "",
                    shape ? `${shape} Shaped` : "",
                    cut ? `${cut} Cut` : "",
                    color ? `${color} Color` : "",
                    clarity ? `${clarity} Clarity` : "",
                    lab ? `${lab} Certified` : "",
                    certifiedTitle || ""
                ]
                .filter(value => value && value.trim() !== "")
                .join(", ");

                $(".stone_to_setting_title").text(productTitle);
                $(".setting_title_price").text(price);
                $(".setting_title_cut").text(cut + " Cut");
                $(".setting_title_clarity").text(clarity + " Clarity");
                $(".setting_title_color").text(color + " Color");

                 $('.image-stone-to-settings').append(`
                    <img src="${image_url}" class="product-media--diamond-image" width="100%" height="100%" onerror="this.onerror=null; this.src='${no_image_url}';"  />
                `);
                
                $(".vdbrc_complete_my_ring_btn").attr({
                    "data-stock-num": stock_num,
                    "data-stock-id": stock_id,
                    "data-shape": shape,
                    "data-size": size,
                    "data-color": color,
                    "data-clarity": clarity,
                    "data-cut": cut,
                    "data-lab": lab,
                    "data-price": price,
                    "data-original-price": price_without_format,
                    "data-image": image_url,
                    "data-title": productTitle
                });
            }
        }
    }
    } finally {
        $('.product-review-section').removeClass('vdb-stone-loading');
    }

    if (ringSize && ringSize.trim() !== '') {
        $('#Option-ring-size').val(ringSize).trigger('change');
        $('.ring-size-trigger-text').text(ringSize);
    }
});

async function get_stone_info(stone_stock_num, stockNumParam) {
    if (!stone_stock_num) {
        console.error("Stone stock number is required");
        return null;
    }

    const sendData = new URLSearchParams();
    sendData.append("action", "get_stone_details");
    sendData.append("shop", shop);
    sendData.append(stockNumParam, stone_stock_num);

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = JSON.parse(resultData);
                    resolve(parsed);
                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        return responseData;

    } catch (error) {
        console.error("Error loading stones:", error);
        return null;
    }
}

function formatValue(value, defaultValue = "") {
    return value ?? defaultValue;
}
function formatSize(size) {
    return size ? Number(size).toFixed(2) : "";
}

$('body').on('click', '.vdbrc_complete_my_ring_btn', async function () {
    const _this = this;
    const params = new URLSearchParams(window.location.search);

    console.log('Hello');
    const stockNumParam = params.get("origin") === "natural" ? 'natural_stock_num' : 'labgrown_stock_num';
    const variantId = params.get("variant") || '';
    if (variantId === "") {
        alert("Something went wrong. Please try again. Looks like we couldn't find the selected setting product.");
        return;
    }

    const ringSizeValue = $('#Option-ring-size').val().trim();
    if (ringSizeValue === "") {
        alert("Please select the ring size value");
        return;
    }

    const stockNum = $(this).data('stock-num');
    const stockId = $(this).data('stock-id');
    const shape = $(this).data('shape');
    const size = $(this).data('size');
    const color = $(this).data('color');
    const clarity = $(this).data('clarity');
    const cut = $(this).data('cut');
    const lab = $(this).data('lab');
    const price = $(this).data('original-price');
    const image = $(this).data('image');
    const title = $(this).data('title');

    // Stone Product Create & Add To Cart
    if (stockNum && stockId) {
        await addStoneToCart(_this, stockNumParam, stockNum, stockId, price, image, title);
    }
    
   // Setting Product Add To Cart
    const engravingValue = $('input[name="Engraving"]:checked').val();

    let engravingFont = '';
    let engravingFontText = '';

    if (engravingValue === "Yes") {
        engravingFont = $(".vdbrc_engraving_font").text().trim();
        engravingFontText = $(".vdbrc_engraving_font_text").val().trim();
    }

    // Build properties object correctly
    const properties = {
        "_group_id": timestampForATC
    };

    if (engravingFont !== '' && engravingFontText != '') {
        properties["Engraving Font"] = engravingFont;
        properties["Engraving Text"] = engravingFontText;
    }

    if(ringSizeValue !== ''){
        properties["Ring Size"] = ringSizeValue;
    }

    await shopifyAddToCart(variantId, 1, properties);

    // window.location.href = '/cart';
    await refreshAndOpenCartDrawer();

    _this.disabled = true;
    _this.style.pointerEvents = "none";
    _this.style.opacity = "0.6";
    _this.textContent = "Added To Cart";
});

async function refreshAndOpenCartDrawer() {
    const currentDrawer = document.querySelector('cart-drawer');

    if (!currentDrawer) {
        window.location.href = '/cart';
        return;
    }

    const res = await fetch('/cart', {
        method: 'GET',
        credentials: 'same-origin'
    });

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newDrawerInner = doc.querySelector('#CartDrawer');
    const currentDrawerInner = currentDrawer.querySelector('#CartDrawer');

    if (!newDrawerInner || !currentDrawerInner) {
        window.location.href = '/cart';
        return;
    }

    currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

    // Important fix
    currentDrawer.classList.remove('is-empty');
    currentDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');

    const newCartBubble = doc.querySelector('#cart-icon-bubble');
    const currentCartBubble = document.querySelector('#cart-icon-bubble');

    if (newCartBubble && currentCartBubble) {
        currentCartBubble.innerHTML = newCartBubble.innerHTML;
    }

    currentDrawer.open();
}

//#region : Add to Cart Logic
async function addStoneToCart(atcElement, stockNumKey, stockNum, stockId, price, image, title) {
    const sendData = new URLSearchParams();
    sendData.append("action", "add_product_info");
    sendData.append("shop", shop);
    sendData.append(stockNumKey, stockNum);
    sendData.append("stock_id", stockId);
    sendData.append("product_price", price);
    sendData.append("prod_img", image);
    sendData.append("product_title", title);

    atcElement.disabled = true;
    atcElement.style.pointerEvents = "none";
    atcElement.style.opacity = "0.6";
    atcElement.textContent = "Please wait...";

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = JSON.parse(resultData);
                    resolve(parsed);

                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        if (!responseData || !responseData.success || !responseData.data || !responseData.data.var_id) {
            alert('Failed to prepare stone variant. Please try again.');
            return;
        }
        const variantId = responseData.data.var_id;

        await shopifyAddToCart(variantId, 1, {
            "Stock ID": stockId,
            "Stock Number": stockNum,
            "_group_id": timestampForATC
        });
    } catch (error) {
        console.error("Error adding stone to cart:", error);
        alert(error?.message || 'An error occurred while adding the stone to cart. Please try again.');
    } finally {
        atcElement.disabled = false;
        atcElement.style.pointerEvents = "auto";
        atcElement.style.opacity = "1";
        atcElement.textContent = "Add to Cart";
    }
}
async function shopifyAddToCart(variantId, qty = 1, properties = null) {
    const payload = {
        id: Number(variantId),
        quantity: qty
    };

    // Optional: line item properties (shows under item in cart)
    if (properties && typeof properties === "object") {
        payload.properties = properties;
    }

    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });

    // Shopify returns 200 + JSON on success, 4xx + JSON on error
    const data = await res.json().catch(() => null);

    if (!res.ok) {
        const msg = (data && (data.description || data.message)) || 'Shopify cart add failed';
        throw new Error(msg);
    }

    return data; // contains added line item object
}
//#endregion

//#region : General Functions
function handlePriceData(stoneCurrencyCode, total_sales_price, withoutFormate = false) {
    // Helper function to check if a value is defined and not empty
    function isValidCurrency(currency) {
        return currency !== undefined && currency !== null && currency !== "";
    }
    // Initial price conversion to shop currency
    let price = Math.round(price_in_shop_currency(total_sales_price));
    if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
        if (stoneCurrencyCode !== shop_currency) {
            // Convert to USD first, then to shop currency
            let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
            price = Math.round(price_in_shop_currency(usd_price));
        } else {
            price = Math.round(total_sales_price);
        }
    }
    if (withoutFormate) {
        price = Math.round(total_sales_price);
    } else {
        price = vdbrcFormatMoney(price * 100, moneyFormat);
    }
    // Convert price to market currency if different from shop currency
    if (market_currency !== shop_currency) {
        price = Math.round(price_in_market_currency(total_sales_price));
        if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
            if (stoneCurrencyCode !== market_currency) {
                // Convert to USD first, then to market currency
                let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
                price = Math.round(price_in_market_currency(usd_price));
            } else {
                price = Math.round(total_sales_price);
            }
        }
        if (withoutFormate) {
            price = Math.round(total_sales_price);
        } else {
            price = vdbrcFormatMoney(price * 100, market_currency_symbol + " {amount}");
        }
    }
    return price;
}
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}
function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}
function updateUrl(url, key, value) {
    var hashIndex = url.indexOf("#");

    if (hashIndex === -1) {
        hashIndex = url.length;
    }

    var urlWithoutHash = url.substring(0, hashIndex);
    var hash = url.substring(hashIndex);

    var urls = urlWithoutHash.split("?");
    var baseUrl = urls[0];
    var parameters = urls.length > 1 ? urls[1] : "";
    var outPara = {};

    if (parameters !== "") {
        parameters = parameters.split("&");

        for (var k in parameters) {
            var keyVal = parameters[k].split("=");
            var ekey = keyVal[0];
            var evalue = keyVal.length > 1 ? keyVal[1] : "";

            if (
                ekey !== "" &&
                evalue !== "null" &&
                evalue !== "undefined" &&
                evalue !== ""
            ) {
                outPara[ekey] = evalue;
            }
        }
    }

    if (value === null || value === undefined || value === "") {
        delete outPara[key];
    } else {
        outPara[key] = encodeURIComponent(value);
    }

    var finalParams = [];

    for (var paramKey in outPara) {
        if (
            outPara[paramKey] !== null &&
            outPara[paramKey] !== undefined &&
            outPara[paramKey] !== "" &&
            outPara[paramKey] !== "null" &&
            outPara[paramKey] !== "undefined"
        ) {
            finalParams.push(paramKey + "=" + outPara[paramKey]);
        }
    }

    var finalUrl = baseUrl;

    if (finalParams.length > 0) {
        finalUrl += "?" + finalParams.join("&");
    }

    return finalUrl + hash;
}
function resetDeepLink(keepParams = ['origin']) {
    const url = new URL(window.top.location.href);
    const searchParams = new URLSearchParams(url.search);

    // Remove everything except allowed params
    for (const key of Array.from(searchParams.keys())) {
        if (!keepParams.includes(key)) {
            searchParams.delete(key);
        }
    }

    const newQuery = searchParams.toString();
    const newUrl = url.pathname + (newQuery ? `?${newQuery}` : '') + url.hash;

    window.top.history.pushState({}, '', newUrl);
}
//#endregion